import React from "react";
import type { ReactElement } from "react";
import type { CompactMetricEnvelope } from "../../../../shared/metrics";
import { definitionCopy } from "../../lib/snapshot-display";

/**
 * Body of the metric definition popover. A standalone component so tests can
 * render it directly: a closed Radix popover renders no content.
 */
export function MetricDefinition({
  title,
  metric,
}: {
  title: string;
  metric: CompactMetricEnvelope;
}): ReactElement {
  const copy = definitionCopy(metric);

  return (
    <div className="flex max-w-[320px] flex-col gap-2 text-body leading-[1.45] text-foreground">
      <p>
        <strong className="font-semibold">{title}.</strong> {copy.definition}
      </p>
      <p className="text-muted-strong">
        <span className="font-semibold text-foreground">Zones</span> — {copy.zones}
      </p>
      <p className="text-xs text-muted-foreground">
        Source: {copy.source} · data through {copy.dataThrough} · {copy.window}
      </p>
    </div>
  );
}
